import Feel from './Feel';

export default Feel;
